import { PersonaType } from '@bechtel/types';

export const unassignedList = [
  { id: 1, value: PersonaType.FIELD_ENGINEER, label: 'No Field Engineer Assigned', scope: [true, false] },
];
